<template>
  <div>
    <title>微门店用户</title>
    <section class="mainPart">
      <!--S 公用头部切换-->
      <!-- <CompanyTab :active="currentTit"></CompanyTab> -->
      <!--E 公用头部切换-->
      <!--S 检索-->      
      <el-form :inline="true" :model="distributeForm" class="searchForm">
          <el-form-item label="关键词">
              <el-input clearable v-model="distributeForm.keyword" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="激活时间">
              <el-date-picker v-model="distributeForm.time" type="daterange" align="right" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" @click="getActRecords">查询</el-button>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" plain @click="getActRecordsExporturl" v-if="payRecordList.length > 0">导出</el-button>
          </el-form-item>
      </el-form>
      <!--E 检索-->
      <!-- S 列表 -->
      <el-table class="comTable orderTable" ref="gsTable" :data="payRecordList" border :maxHeight="tableHeight" v-loading="isLoad">
        <el-table-column label="序号" type="index" fixed prop="serial"></el-table-column>
        <el-table-column label="微门店名称" min-width="120">
          <template slot-scope="scope">
            <span class="textFl" :title="scope.row.coperuname">{{scope.row.coperuname}}</span>
          </template>
        </el-table-column>
        <el-table-column label="激活时间" min-width="120" sortable prop="operdate">
          <template slot-scope="scope">
            <span>{{dateTime(scope.row.operdate,1)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="总数" sortable prop="opernum">
            <template slot-scope="scope">
                <router-link :to="{path:'/CompanyRecordTotal',query:{'batchcode':scope.row.batchcode,batchNum: scope.row.opernum}}" class="total priceFont"><i class="iconhand"></i>{{scope.row.opernum}}</router-link>
            </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <span class="textFl" :title="scope.row.memo">{{scope.row.memo || '--'}}</span>
          </template>
        </el-table-column>
        <template slot="empty" v-if="isLoad">
            <div :class="{noData:isLoad}"></div>
        </template>
        <template slot="empty" v-else>
          <div class="noData"><span>暂无数据</span></div>
        </template>
      </el-table>
      <!-- E 列表 -->
      <!-- S 分页 -->
      <Page :pageTotal="pagebean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
      <!-- E 分页 -->
    </section>
  </div>
</template>
<script>
import api from '@/apis/api.js';
import { Message, MessageBox } from "element-ui";
export default {
  name: 'CompanyActivationRecord',
  data () {
    return {
      isLoad:false,//加载中
      currentTit:1, //当前选中菜单
      //检索
      distributeForm: {
        keyword: "", //关键词
        time:"",//时间
      },
      payRecordList:[],//列表信息
      tableHeight: window.innerHeight*.8, //表格动态高度
      pickerOptions: {
        shortcuts: [
          {
              text: "今天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime());
                picker.$emit("pick", [start, end]);
              }
            },{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      pageSize: 30, // 每页展示的条数
      currentPage: 1, // 当前请求的页数
      pagebean: {
          totalnum: 0,
      }, // 获取到的列表分页信息
    }
  },
  components: {
    CompanyTab: resolve => require(["@/components/ManageFolder/CompanyTab.vue"],resolve), //头部tab组件
    Page: resolve => require(["@/components/common/Page.vue"],resolve)
  },
  methods: {
    // 获取激活记录
    getActRecords(){
      let params = {
        keyword:this.distributeForm.keyword,
        stime:this.distributeForm.time&&this.distributeForm.time[0]?this.dateTime(this.distributeForm.time[0]) : '',
        etime:this.distributeForm.time&&this.distributeForm.time[1]?this.dateTime(this.distributeForm.time[1]) : '',
        pageparam:{
          pagesize: this.pageSize, //每页条数
          currentpage: this.currentPage, //当前页数
          isnewcomp: 1 //是否需要重新统计页数
        } 
      }
      this.isLoad = true;
      api.GET_ACTRECORDS(params).then((res) => {
        if(res.data.status == '200'){
          this.isLoad = false;
          this.payRecordList = res.data.data;
          if(res.data.pagebean){
            this.pagebean = res.data.pagebean
          }
        }
      })
    },
    // 接收分页信息
    updatePage(size,num) {
        this.pageSize = size;
        this.currentPage = num;
        this.getActRecords();
    },
    // 导出表格
    getActRecordsExporturl() {
      let params = {
        keyword:this.distributeForm.keyword,
        stime:this.distributeForm.time&&this.distributeForm.time[0]?this.dateTime(this.distributeForm.time[0]) : '',
        etime:this.distributeForm.time&&this.distributeForm.time[1]?this.dateTime(this.distributeForm.time[1]) : '',
      }
      api.GET_ACTRECORDSEXPORTURL(params).then((res) => {
        if(res.data.status == '200'){
          this.$message.success('导出成功！');
          window.location.href = res.data.data
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130; 
    },
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted () {
    //在dom渲染之后
    setTimeout(()=>{
      this.getHeight();
    },200);
    this.getActRecords();
  },
  destroyed(){ 
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
@import '../Css/style.css';
.mainPart {padding: 20px; height: calc(100% - 50px);}
/*列表*/
.searchForm>>>.el-range-editor.el-input__inner{width:300px;}
.total{
    line-height: 20px;
    font-weight: bold;
}
.total i {
    font-size: 20px;
    margin-right: 5px;
    vertical-align: text-bottom;
}
</style>




// WEBPACK FOOTER //
// src/views/ManageFolder/PlatformUser/CompanyActivationRecord.vue